import configure from './fetch';

configure();



// WEBPACK FOOTER //
// ../globals/index.js